import * as _ from 'lodash-es';
import { MAT_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { Router } from '@angular/router';
//@ts-ignore
import Mustache from 'mustache';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-notif',
    templateUrl: './notif.component.html',
    styleUrls: ['./notif.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, MatIcon, MatButton]
})
export class NotifComponent implements OnInit {
    protected _options = inject(MAT_SNACK_BAR_DATA);
    protected alert = inject(AlertService);
    protected router = inject(Router);


    get classes(): any {
        return {
            success: this.options.success || false,
            error: this.options.error || false,
            'alert-text': true
        };
    }

    get options(): any {
        return this._options || {};
    }

    get date() {
        return this.options.date;
    }

    get message() {
        return Mustache.render(this.options.message, {
            ...this.options.data
        });
    }

    ngOnInit(): void { }

    isMessage(): boolean {
        return !this.isSuccess() && !this.isError();
    }

    isSuccess(): boolean {
        return this.options.success === true;
    }

    isError(): boolean {
        return this.options.error === true;
    }

    goToURL() {
        // console.log(this);
        if (!this.options.opts?.external) {
            window.open('#/' + this.options.url, '_blank');
        } else {
            window.open(this.options.url, '_blank');
        }
    }

    dismiss(event: Event) {
        event.stopPropagation();
        this.alert.reset();
    }
}
